/**
 * Vuelta al menú de Winegang (app.winegang.es), donde están todos los juegos.
 *
 * Solo va en el inicio y en el login. Dentro del juego, volver lleva al inicio
 * del juego, y desde ahí este botón lleva al menú: así nunca hay dos «volver»
 * a la vez. En la app (Capacitor) el juego se abre en la misma vista que el
 * menú, y este enlace es la forma de regresar.
 */
export const MENU_WINEGANG = 'https://app.winegang.es/';

// El botón solo tiene sentido dentro de la app de Winegang, que es donde está el
// menú con todos los juegos; en la web móvil no se enseña. La app se reconoce
// por su user agent (WinegangApp), por el puente de Capacitor o por el ?app=1
// con el que el menú abre el juego, que se recuerda para el resto de visitas.
// Se mira al cargar el módulo, antes de que el router pueda quitar el ?app=1.
const CLAVE_APP = 'enAppWinegang';
function detectarApp() {
  try {
    if (new URLSearchParams(window.location.search).get('app') === '1') {
      localStorage.setItem(CLAVE_APP, '1');
    }
    return /WinegangApp/.test(navigator.userAgent)
      || Boolean(window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform())
      || localStorage.getItem(CLAVE_APP) === '1';
  } catch (e) {
    return false;
  }
}
export const EN_APP_WINEGANG = detectarApp();

export default function VolverWinegang() {
  if (!EN_APP_WINEGANG) return null;
  return (
    <a href={MENU_WINEGANG} className="volver-winegang" aria-label="Volver al menú de Winegang con todos los juegos">
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6" /></svg>
      <span>Todos los juegos</span>
    </a>
  );
}
